export interface ColorSet {
  bg: string;
  text: string;
  border: string;
  light: string;
  fill: string;
  stroke: string;
}

const COLOR_MAP: Record<string, ColorSet> = {
  blue: { bg: 'bg-blue-500', text: 'text-blue-700', border: 'border-blue-500', light: 'bg-blue-50', fill: '#3B82F6', stroke: '#2563EB' },
  cyan: { bg: 'bg-cyan-500', text: 'text-cyan-700', border: 'border-cyan-500', light: 'bg-cyan-50', fill: '#06B6D4', stroke: '#0891B2' },
  accent: { bg: 'bg-accent-500', text: 'text-accent-700', border: 'border-accent-500', light: 'bg-accent-50', fill: '#6366F1', stroke: '#4F46E5' },
  emerald: { bg: 'bg-emerald-500', text: 'text-emerald-700', border: 'border-emerald-500', light: 'bg-emerald-50', fill: '#10B981', stroke: '#059669' },
  amber: { bg: 'bg-amber-500', text: 'text-amber-700', border: 'border-amber-500', light: 'bg-amber-50', fill: '#F59E0B', stroke: '#D97706' },
  red: { bg: 'bg-red-500', text: 'text-red-700', border: 'border-red-500', light: 'bg-red-50', fill: '#EF4444', stroke: '#DC2626' },
  purple: { bg: 'bg-purple-500', text: 'text-purple-700', border: 'border-purple-500', light: 'bg-purple-50', fill: '#8B5CF6', stroke: '#7C3AED' },
  gray: { bg: 'bg-gray-500', text: 'text-gray-700', border: 'border-gray-500', light: 'bg-gray-50', fill: '#6B7280', stroke: '#4B5563' },
};

const DEFAULT_COLORS = ['blue', 'emerald', 'amber', 'purple', 'cyan', 'red'];

export function getColor(key?: string): ColorSet {
  return COLOR_MAP[key || 'accent'] || COLOR_MAP.accent;
}

export function getCycleColor(index: number): ColorSet {
  const key = DEFAULT_COLORS[index % DEFAULT_COLORS.length];
  return COLOR_MAP[key];
}

export function getSvgColor(key?: string): string {
  return (COLOR_MAP[key || 'accent'] || COLOR_MAP.accent).fill;
}
